<template>
  <div>
    <div style="padding-top: 20px;">
      <van-radio-group v-model="radio" direction="horizontal" icon-size="25px" style="justify-content: center;">
        <van-radio v-for="(item, key) in dataName" :key="key" :name="item" @click="onSelect(item)">{{ item }}</van-radio>
      </van-radio-group>
      <div v-if="textList.length" style="color: red;font-size: 14px;text-align: center;padding-top: 10px;">注：{{ textList }} 没有填写</div>
    </div>

    <div id="main" style="height:800px;width: 100%;" ref="main"></div>
  </div>
</template>
 
<script>
import echarts from "echarts";

export default {
  data() {
    return {
      textList: ['阮洋', '傅璟', '王伟峰', '孙家兴', '胡石军', '徐绍殷', '黄悦凯', '陈豪杰', '赵赛君', '谢贞云', '吴昌悦', '高伟荣', '梁泳梅', '陈柏光'],
      radio: '阮洋',
      dataList: [],
      dataName: ['阮洋', '傅璟', '王伟峰', '孙家兴', '胡石军', '徐绍殷', '黄悦凯', '陈豪杰', '赵赛君', '谢贞云', '吴昌悦', '高伟荣', '梁泳梅', '陈柏光']
    }
  },
  mounted() {
    // this.getData().then( async () => {
    //   await this.drawLine()
    // })
    this.onSelect(this.radio)
  },
  methods: {
    onSelect(name) {
      this.textList = ['阮洋', '傅璟', '王伟峰', '孙家兴', '胡石军', '徐绍殷', '黄悦凯', '陈豪杰', '赵赛君', '谢贞云', '吴昌悦', '高伟荣', '梁泳梅', '陈柏光']
      this.dataList = []
      this.getData(name).then( async () => {
        await this.drawLine()
      })
    },
    async getData(name) {
      const result = await this.$request({
        url: '/api/GeneralMethod/getFunctionList',
        method: 'GET',
        params: {
          Model: 'appraise',
          dateTime: this.$route.query.date,
          appraisedUser: name
        }
      })
      if (result.success) {
        let list = result.data
        list.forEach(item => {
          const index = this.textList.findIndex(i => i === item.name)
          this.textList.splice(index, 1)
        })
        this.dataName.forEach(item => {
          const arr = list.filter(i => item === i.appraisedUser)
          if (arr.length === 14) {
            const sums = []
            arr.forEach(r => {
              if (r.appraisedUser === '阮洋') {
                Object.getOwnPropertyNames(r).forEach(function (key) {
                    if (key.includes('v')) {
                      r[key] = r[key]/14
                    }
                  })
              } else {
                if (r.name === '阮洋') {
                  Object.getOwnPropertyNames(r).forEach(function (key) {
                    if (key.includes('v')) {
                      r[key] = r[key]*0.4
                    }
                  })
                } else if (r.name === item) {
                  Object.getOwnPropertyNames(r).forEach(function (key) {
                    if (key.includes('v')) {
                      r[key] = r[key]*0.3
                    }
                  })
                } else {
                  Object.getOwnPropertyNames(r).forEach(function (key) {
                    if (key.includes('v')) {
                      r[key] = r[key]/40
                    }
                  })
                }
              }

              // 遍历对象的属性
              for (let key in r) {
                // 检查属性是否以 'v' 开头
                if (key.startsWith('v')) {
                  const index = parseInt(key.slice(1)) - 1

                  // 如果结果数组中不存在对应索引的元素，则进行初始化
                  if (!sums[index]) {
                    sums[index] = 0
                  }
                  // 将属性值累加到结果数组对应的索引位置
                  sums[index] += r[key]
                }
              }
            })
            const roundedSums = sums.map(sum => Math.round(sum))

            this.dataList.push({ name: item, value: roundedSums })

          }
          
        })

        // console.log(this.dataList)
      }

    },
    drawLine() {
      const myChart = echarts.init(this.$refs.main); 
      let figureData = [
        { name: '业务理解能力', max: 5 },
        { name: '需求分析/需求管理能力', max: 5 },
        { name: '市场调研/研究能力', max: 5 },
        { name: '产品运营/用户运营/增长能力', max: 5 },
        { name: '产品规划/架构/设计/开发能力', max: 5 },
        { name: '工具能力', max: 5 },
        { name: '项目管理能力', max: 5 },
        { name: '度量及数据分析能力', max: 5 },
        { name: '主观能动性', max: 5 },
        { name: '情商', max: 5 },
        { name: '抗压能力', max: 5 },
        { name: '学习与提炼能力', max: 5 },
        { name: '团队影响力/领导力', max: 5 },
        { name: '协同协调能力', max: 5 },
        { name: '谈判沟通能力', max: 5 },
        { name: '快速交付/执行能力', max: 5 }
      ]
      // let data = [
      //   { name: '阮洋', value: [1, 5, 1, 5, 1, 5, 1, 5, 1, 5, 1, 5, 1, 5, 1, 5] },
      //   { name: '傅璟', value: [1, 5, 2, 5, 4, 5, 2, 5, 1, 5, 2, 5, 1, 5, 1, 5] }
      //   // ...以此类推
      // ]
      
      let option = {
        legend: {
          show: false,
          data: this.dataName // 数据名
        },
        tooltip: { // 设置展示雷达图详细参数
          show: true,
          trigger: 'item',
        },
        radar: {
          name: {
            show: true,
            fontSize: 16,
            fontFamily: "Source Han Sans CN",
            fontWeight: "bold",
            color: "#333333"
          },
          indicator: figureData,
        }, // 雷达图参数
        series: [
          {
            type: 'radar',
            label: { show: false, }, // 是否显示值
            areaStyle: {
              color: new echarts.graphic.RadialGradient(0.1, 0.6, 1, [
              {
                color: 'rgba(255, 145, 124, 0.1)',
                offset: 0
              },
              {
                color: 'rgba(255, 145, 124, 0.9)',
                offset: 1
              }
            ])
            }, // 阴影
            animationDuration: 3000, // 动画时间
            data: this.dataList // data,
          }
        ]
      }
      myChart.setOption(option)
    },
  },
}
</script>
